/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @type {QuestionComponent<FormQuestion<null>>}
 */
const SimplicityFormParagraph = (props) => {

    const { field } = props
    const { content } = field || {}

    if (!content) {
        return null
    }

    return (
        <p className="simplicity-forms-paragraph">{content}</p>
    )
}

export { SimplicityFormParagraph };

